<template>
    <div class="panel">
        <div class="panel-body">

            <el-table :data="lineArr" v-if="lineArr.length != 0">
                <el-table-column v-for="(col, index) in level1RecordColNameArr" v-bind:key="col" :label="col.label"
                                 :key="index">
                    <template slot-scope="scope">
                        {{ scope.row[index].props }}
                    </template>
                </el-table-column>
            </el-table>

        </div>
    </div>
</template>

<script>
    import AssessmentServer from "../../../api/assessment";
    import {debounce} from "../../../util/common";

    export default {
        name: "assessmentRecordLevel1Table",

        props: ['assessmentid'],

        data() {
            return {

                assessmentRecordArr: [],
                level1RecordArr: [],

                level1RecordColNameArr: [],     //动态列名

                lineArr: [],    //表格最终数据

                col1Name: '名称',
                typeArr: ['评分分值', '权重'],       //类别：评分分值、权重

            }
        },

        methods: {

            queryAssetmentRecordLevel1Table(assessmentid) {

                let me = this;
                if(assessmentid == -1){
                    me.lineArr = [];
                    return;
                }
                AssessmentServer.assessmentRecord.list({assessmentid: assessmentid}).then(responseBody => {
                    if (responseBody.data.code == 200) {
                        me.lineArr = [];
                        me.assessmentRecordArr = responseBody.data.data;
                        me.level1RecordArr = responseBody.data.data.filter(e => {
                            return e.config.level == 1;
                        });
                        console.log(me.assessmentRecordArr);

                        //动态列名（组合第一列 和 其余配置大类）
                        //名称
                        me.level1RecordColNameArr = [];
                        me.level1RecordColNameArr.push({
                            label: me.col1Name,
                        });
                        //其余配置的大类
                        me.level1RecordArr.forEach(e => {
                            me.level1RecordColNameArr.push({
                                label: e.config.category,
                                props: e.config.category,
                            });
                        });

                        //表格内容填充
                        let l1 = [];    //第一行
                        let l2 = [];    //第二行
                        for (let i = 0; i < me.level1RecordArr.length; i++) {
                            let obj1 = {
                                label: me.level1RecordArr[i].config.category,
                                props: me.level1RecordArr[i].score,
                            };
                            l1.push(obj1);
                            let obj2 = {
                                label: me.level1RecordArr[i].config.category,
                                props: `${me.level1RecordArr[i].config.weight}%`,
                            };
                            l2.push(obj2);
                        }

                        //添加第二行名称：评分分值与权重
                        l1.unshift({
                            label: me.col1Name,
                            props: me.typeArr[0],
                        });
                        l2.unshift({
                            label: me.col1Name,
                            props: me.typeArr[1],
                        });
                        me.lineArr.push(l1);
                        me.lineArr.push(l2);

                        // console.log(me.lineArr);

                        this.$emit("afterQueryAssessmentRecordLevel1Table",  this.sumTotal(this.level1RecordArr));
                    }

                });
            },

            sumTotal(level1RecordArr) {
                let total = 0;
                level1RecordArr.forEach(e => {
                    total += e.score * e.config.weight * 0.01;
                });
                return  Math.round(total * 100) / 100;
            },

        },

        watch: {
            assessmentid: {
                handler: debounce(function (newVal, oldVal) {
                    this.queryAssetmentRecordLevel1Table(newVal);
                }, 100)
            }
        },

    }


</script>

<style scoped>

</style>